import { mapLatestScanJobsToHandoff } from '@wix/a11y-wizard-common';
import { getLatestScan } from '@wix/ambassador-promote-accessibility-v2-item-type-scan-summary/http';
/**
 * Fetches the latest scan for the current site, including analyze job IDs when available.
 */
export const fetchLatestScan = async (httpClient, errorHandler) => {
  const {
    withErrorHandler
  } = errorHandler;
  let latestScan = null;
  await withErrorHandler(async () => {
    const {
      data: {
        latestScan: scan
      }
    } = await httpClient.request(getLatestScan({}));
    if ((scan == null ? void 0 : scan.id) == null || scan.scanDate == null) {
      return;
    }
    const scanWithJobs = scan;
    latestScan = {
      id: scan.id,
      jobs: mapLatestScanJobsToHandoff(scanWithJobs.jobs),
      scanDate: new Date(scan.scanDate),
      scanType: scan.scanType
    };
  }, {
    errorCodesMap: {}
  });
  return latestScan;
};
//# sourceMappingURL=fetch-latest-scan.js.map